import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createMatomoTracker, MatomoProvider } from "frno-react";

const matomoHost = process.env.REACT_APP_MATOMO_HOST || "";
const matomoSiteId = Number(process.env.REACT_APP_MATOMO_SITE_ID) ?? -1;
const matomoEnabled: boolean = !!(matomoHost && matomoSiteId);

const matomoInstance = createMatomoTracker({
  urlBase: matomoHost,
  siteId: matomoSiteId,
  disabled: !matomoEnabled,
});

console.log(matomoHost, matomoSiteId);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <MatomoProvider instance={matomoInstance}>
      <App />
    </MatomoProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
